<span class="badge rounded-pill text-secondary" data-cy="SPAN-c7b7">
  <ng-content></ng-content>
</span>
